import { render, staticRenderFns } from "./AITrainingPanel.vue?vue&type=template&id=35aab200&scoped=true"
import script from "./AITrainingPanel.vue?vue&type=script&lang=js"
export * from "./AITrainingPanel.vue?vue&type=script&lang=js"
import style0 from "./AITrainingPanel.vue?vue&type=style&index=0&id=35aab200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aab200",
  null
  
)

export default component.exports